import React from 'react';

const reviewsData = [
  {
    name: "Sara M.",
    handle: "Mamma di Leo (4 mesi)",
    text: "La sessione di idroterapia è stata magica! Leo ha dormito per 6 ore di fila dopo – un nuovo record! Abbiamo prenotato subito un'altra sessione."
  },
  {
    name: "Giacomo T.",
    handle: "Papà di Bella (6 mesi)",
    text: "Un ambiente così rilassante. Lo staff è stato incredibilmente gentile con Bella e ci ha insegnato ottime tecniche di massaggio da usare a casa."
  },
  {
    name: "Emilia R.",
    handle: "Mamma di Noa (2 mesi)",
    text: "Noa soffriva di coliche, ma il galleggiamento in acqua calda sembra averlo davvero calmato. Vederlo sorridere e scalciare liberamente non ha prezzo."
  },
  {
    name: "Martina L.",
    handle: "Mamma di Sofia (5 mesi)",
    text: "Semplicemente meraviglioso. Vedere la mia bambina così felice e rilassata nell'acqua è stata un'emozione unica. Consigliatissimo!"
  }
];

// Duplicate data to create seamless loop
const carouselData = [...reviewsData, ...reviewsData];

const Reviews = () => {
  return (
    <section className="reviews-section">
      <h2>Amato da Genitori e Bambini</h2>
      <p>Valutato 5 stelle da genitori felici che hanno visto<br />gli incredibili benefici dell'idroterapia.</p>
      <div className="stars">★★★★★</div>

      <div className="carousel-window">
        <div className="carousel-track">
          {carouselData.map((review, index) => (
            <div className="review-card" key={index}>
              <div className="reviewer-meta">
                <div className="avatar"></div>
                <div>
                  <strong>{review.name}</strong><br />
                  <span className="twitter-handle">{review.handle}</span>
                </div>
              </div>
              <p className="review-text">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;